import { defineStore } from 'pinia'
import { removeDuplicatesAndEmpty } from '@/Shared/helper.js'

export const useFavoriteBrandsStore = defineStore('favoriteBrands', {

  state: () => ({
    list: [],
  }),

  getters: {
    getList() {
      return this.list
    },
  },
  
  actions: {
    updateList(_list) {
      this.list = removeDuplicatesAndEmpty(_list)
    },
    addItem(_item) {
      this.list = removeDuplicatesAndEmpty([...this.list, _item])
    },
    removeItem(_item) {
      this.list = removeDuplicatesAndEmpty([...this.list].filter(item => item !== _item))
    },
  },

})
